import dynamic from 'next/dynamic';

export const LinkBannerDynamic = dynamic(() => import('./LinkBanner').then(module => module.LinkBanner));
export { LinkBanner } from './LinkBanner';
